import lodash from 'lodash';
import type { LotteryFormTemplate } from './types';

// This template is used for EditLottery and needs to contain all modules
export const allModulesTemplate: LotteryFormTemplate = {
  general: ['general', 'monthly-occurrence', 'single-occurrence', 'weekly-occurrence'],
  legal: ['legal', 'email-subscription'],
  signup: ['purchase', 'swipe', 'simple-signup', 'minimum-purchase-amount'],
  selectWinners: ['winners', 'max-winners-per-store', 'email-marketing-constraint'],
  winnerCommunication: ['claim-my-prize', 'email', 'no-communication'],
};

export const purchaseLottery: LotteryFormTemplate = {
  general: ['general'],
  legal: ['legal'],
  signup: ['purchase', 'minimum-purchase-amount'],
  selectWinners: ['winners', 'max-winners-per-store', 'email-marketing-constraint'],
  winnerCommunication: [],
};

export const swipeLottery: LotteryFormTemplate = {
  general: ['general'],
  legal: ['legal', 'email-subscription'],
  signup: ['swipe'],
  selectWinners: ['winners'],
  winnerCommunication: [],
};

export const simpleSignupLottery: LotteryFormTemplate = {
  general: ['general'],
  legal: ['legal', 'email-subscription'],
  signup: ['simple-signup'],
  selectWinners: ['winners'],
  winnerCommunication: [],
};

export const purchaseAndSimpleSignupLottery: LotteryFormTemplate = {
  general: ['general'],
  legal: ['legal', 'email-subscription'],
  signup: ['purchase', 'simple-signup'],
  selectWinners: ['winners', 'max-winners-per-store'],
  winnerCommunication: [],
};

// Map template id as they are stored to the actual template
const idToTemplate: Record<string, LotteryFormTemplate> = {
  'monthly-purchase': purchaseLottery,
  swipe: swipeLottery,
  'simple-signup': simpleSignupLottery,
  'purchase-and-simple-signup': purchaseAndSimpleSignupLottery,
};

export const getTemplate = (id: keyof typeof idToTemplate): LotteryFormTemplate =>
  lodash.cloneDeep(idToTemplate[id]);
